import { notificationApi } from "@/core/data/api";

export default async (query) => {
  return await notificationApi.getNotificationListPagination(query);
};
